import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';

import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import LabelName from 'components/UI/LabelName/LabelName';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';

function CaseName({ control, notLinkedToCaseWatcher, errors, setValue }) {
  const { versionFileUpload, selectedItem, fileManagerFilters, isClientFileManager } = useFileManagerContext();

  const isDisabled =
    notLinkedToCaseWatcher ||
    (versionFileUpload && selectedItem.case_id !== 'undefined') ||
    fileManagerFilters.case ||
    selectedItem?.case_name === '';

  useEffect(() => {
    if (fileManagerFilters?.case) {
      setValue('case', fileManagerFilters?.case || {});
    }
  }, [fileManagerFilters?.case]);

  useEffect(() => {
    if (versionFileUpload) {
      setValue('case', { id: fileManagerFilters?.case?.id, label: fileManagerFilters?.case?.case_name });
    }
  }, []);

  return (
    <div className="case-search-wrapper d-flex py-2 flex-wrap file-manager-case-wrap align-items-center">
      <div className="col-md-3 col-12">
        <LabelName required={!notLinkedToCaseWatcher} htmlFor="case" className="mt-2">
          Case/Lead
        </LabelName>
      </div>
      <div className="col-md-9 col-12">
        <Controller
          name="case"
          control={control}
          rules={{
            required: !notLinkedToCaseWatcher ? true : false,
            validate: (value) => (!notLinkedToCaseWatcher ? typeof value === 'object' : true),
          }}
          render={({ field }) => (
            <CaseListDropDown
              isClient={isClientFileManager}
              value={selectedItem?.case_name === '' ? null : field?.value}
              onChange={(e) => field?.value !== e && field.onChange(e)}
              name="case"
              placeholder="Case/Lead Name"
              noOptionsMessage="No Cases/Leads Found"
              isClearable
              disabled={isDisabled}
            />
          )}
        />
        {errors?.case?.type === 'required' && <InputErrorMessage>Please select case/lead</InputErrorMessage>}
        {errors?.case?.type === 'validate' && <InputErrorMessage>Please select valid case/lead</InputErrorMessage>}
      </div>
    </div>
  );
}

export default CaseName;
